// Will be used as source of truth for driver identification, other types will be added later
export enum DriverIdOriginTags {
  rfid = 'rfid',
  faceMatch = 'face_match',
  smartTripMatch = 'smart_trip_matching',
  unidentified = 'unidentified',
  manuallyAssigned = 'manually_assigned',
  driverClaimed = 'driver_claimed',
  driverConnected = 'driver_connected',
}
